import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagNl = createSvg(React.createElement(React.Fragment, null,
    React.createElement("g", { fillRule: "evenodd", strokeWidth: "1pt" },
        React.createElement("path", { d: "M0 0h512.005v509.753H0z", fill: "#fff" }),
        React.createElement("path", { d: "M0 342.08h512.005v169.918H0z", fill: "#21468b" }),
        React.createElement("path", { d: "M0 0h512.005v169.918H0z", fill: "#ae1c28" }))), '0 0 512 512', 'FlagNl');
//# sourceMappingURL=FlagNl.js.map